export default __webpack_public_path__ + "static/peter-semple-ef519a74cce9ac91600c943efedd4b79.jpg";